import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/RelatedStores';

export const RELATED_STORES_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const RELATED_STORES_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
